import React from 'react';

import { SpotlightManager } from '@atlaskit/onboarding';

export const LiveDocSpotlightsTourManager = React.memo(
	({ children }: { children: React.ReactNode }) => {
		return <SpotlightManager>{children}</SpotlightManager>;
	},
);
